export const PartNotesValidation = (formData) => {
    const errors = {};
    if (!formData.Notes || !formData.Notes.trim()) {
        errors.Notes = 'This field is required';
    }
    return errors;
};

